import { GraphQLResult } from "@aws-amplify/api";
import { API } from "aws-amplify";
import { Dispatch, DispatchWithoutAction, SetStateAction } from "react";
import { toast } from 'react-toastify';

import { deleteRack } from "../../../graphql/mutations";
import { updateLoading } from "../../../redux/slice/appSlice";
import { AppDispatch } from "../../../redux/store";
import { DeleteRackMutation, Rack } from "../../../types/api";

interface deleteRackByIdProps {
  id: string | undefined;
  index: number;
  dispatch: AppDispatch;
  updateRacks: Dispatch<SetStateAction<(Rack | null)[]>>;
  forceUpdate: DispatchWithoutAction;
}
export const deleteRackById: ({
  id,
  index,
  dispatch,
  updateRacks,
  forceUpdate
}: deleteRackByIdProps) => Promise<void> = async ({
  id,
  index,
  dispatch,
  updateRacks,
  forceUpdate
}: deleteRackByIdProps) => {
  try {
    dispatch(updateLoading(true));
    const deleteResponse: GraphQLResult<DeleteRackMutation> =
      await API.graphql({
        query: deleteRack,
        variables: { input: { id } }
      }) as GraphQLResult<DeleteRackMutation>;
    if (deleteResponse.data?.deleteRack) {
      updateRacks((prevState) => {
        if (prevState) {
          prevState.splice(index, 1);
        }
        return prevState;
      });
      forceUpdate();
    }
  } catch (err) {
    // console.log(err)
    toast.dark("Error: Delete Rack.");
  } finally {
    dispatch(updateLoading(false));
  }
};
